<div class="payment-container">
  <div class="main-border ">
    <div class="d-flex justify-content-center w-50 my-3">
      <img src="assets/icons/succsess.svg" class="w-25">
    </div>
    <p class=" text-center pb-4 pt-3 p_success my-3">{{'This Invoice Is already Paid !' | translate}} </p>
    <button class="btn bg-color-orange " (click)="receipt()"><i class="fa fa-eye"></i> {{"Show Receipt"|
      translate}}</button>
  </div>
</div>